import React from 'react';
import { StatCard } from './shared';

export default function OverviewTab({ stats }) {
  if (!stats) return null;
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <StatCard label="Organisasjoner" value={stats.organizations} color="blue" />
        <StatCard label="Brukere" value={stats.users} color="green" />
        <StatCard label="Oppgaver" value={stats.tasks?.total} color="yellow" />
        <StatCard label="Åpne avvik" value={stats.deviations?.open} color="red" />
      </div>
      
      <div className="bg-gray-800 rounded-lg p-6">
        <h2 className="font-semibold mb-4">Siste organisasjoner</h2>
        <div className="space-y-2">
          {stats.recent_organizations?.map(org => (
            <div key={org.id} className="flex items-center justify-between py-2 border-b border-gray-700 last:border-0">
              <div>
                <div className="font-medium">{org.name}</div>
                <div className="text-sm text-gray-400">Org.nr: {org.orgnr}</div>
              </div>
              <div className="text-sm text-gray-400">
                {new Date(org.created_at).toLocaleDateString('nb-NO')}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
